import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Input } from "@/shared/components/ui/input";
import type { UpsertVersioningScheduleSourceDto, VersioningScheduleModalMode } from "../types/mediaVersionUpdateAlert";

function InfoCallout({ children }: { children: React.ReactNode }) {
    return (
        <Card className="p-3 bg-blue-50 border-blue-200 text-blue-900">
            <div className="text-sm">{children}</div>
        </Card>
    );
}

interface Props {
    open: boolean;
    mode: VersioningScheduleModalMode;
    value: UpsertVersioningScheduleSourceDto;
    onChange: (next: UpsertVersioningScheduleSourceDto) => void;
    onCancel: () => void;
    onSubmit: () => void;
}

export function VersioningScheduleSourceDialog(props: Props) {
    return (
        <Dialog open={props.open} onOpenChange={(open) => !open && props.onCancel()}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>
                    <DialogTitle>{`Versioning Schedule 확인 대상 ${props.mode}`}</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <div className="space-y-2">
                        <div className="text-sm font-medium">매체명</div>
                        <Input
                            value={props.value.channel}
                            onChange={(e) => props.onChange({ ...props.value, channel: e.target.value })}
                            maxLength={64}
                        />
                        <InfoCallout>
                            매체 공식 명칭과 일치하지 않아도 됩니다. (ex: Apple, Google (Sunset Date), Facebook (SDK Version), ...)
                        </InfoCallout>
                    </div>

                    <div className="space-y-2">
                        <div className="text-sm font-medium">URL</div>
                        <Input
                            value={props.value.url}
                            onChange={(e) => props.onChange({ ...props.value, url: e.target.value })}
                            maxLength={1024}
                        />
                        <InfoCallout>크롤링 대상 url을 입력합니다.</InfoCallout>
                    </div>

                    <div className="space-y-2">
                        <div className="text-sm font-medium">Selector</div>
                        <Input
                            value={props.value.selector}
                            onChange={(e) => props.onChange({ ...props.value, selector: e.target.value })}
                            maxLength={1024}
                        />
                        <InfoCallout>
                            URL 내에서 변화를 감시할 요소의 selector를 입력합니다. (Chrome에서 요소 검사 → Copy → Copy selector)
                        </InfoCallout>
                    </div>
                </div>

                <DialogFooter>
                    <Button variant="ghost" onClick={props.onCancel}>
                        취소
                    </Button>
                    <Button onClick={props.onSubmit}>{props.mode}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}